/**
 * Created by lin on 2017/7/28.
 */
let moment = require("moment");
let conf = require("../../config/conf");
let _ = require("lodash");
let urlUtil = require("url");
let qs = require("querystring");//解析参数的库
module.exports = {
    timer() {
        let n_sec = 0; //秒
        let n_min = 0; //分
        let n_hour = 0; //时
        //60秒 === 1分
        //60分 === 1小时
        return setInterval(function () {
            let str_sec = n_sec;
            let str_min = n_min;
            let str_hour = n_hour;
            if (n_sec < 10) {
                str_sec = "0" + n_sec;
            }
            if (n_min < 10) {
                str_min = "0" + n_min;
            }

            if (n_hour < 10) {
                str_hour = "0" + n_hour;
            }

            let time = str_hour + ":" + str_min + ":" + str_sec;
            let ele_timer = time;
            n_sec++;
            if (n_sec > 59) {
                n_sec = 0;
                n_min++;
            }
            if (n_min > 59) {
                n_sec = 0;
                n_hour++;
            }
        }, 1000);
    },
    //获取最近7天日期
    //      getDay(0);//当天日期
    //       getDay(-7);//7天前日期
    //      获取最近3天日期
    //    getDay(0);//当天日期
    //    getDay(-3);//3天前日期
    getDay(day) {
        var today = new Date();
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
        today.setTime(targetday_milliseconds); //注意，这行是关键代码
        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();

        tMonth = this.doHandleMonth(tMonth + 1);

        tDate = this.doHandleMonth(tDate);

        return tYear + "-" + tMonth + "-" + tDate;

    },
    doHandleMonth(month) {
        var m = month;
        if (month.toString().length == 1) {
            m = "0" + month;
        }
        return m;
    },
    //获取时间列表 传入两个时间 时间格式："YYYY-MM-DD"
    getDiffDate(start, end) {
        let startTime = this.getDate(start);
        let endTime = this.getDate(end);
        let dateArr = [];
        while ((endTime.getTime() - startTime.getTime()) >= 0) {
            let year = startTime.getFullYear();
            // "0" +
            // var month = startTime.getMonth().toString().length === 1 ?
            //     ( parseInt(startTime.getMonth().toString(), 10)===9?(parseInt(startTime.getMonth().toString(), 10) + 1):"0"+parseInt(startTime.getMonth().toString(), 10) + 1)
            //     : (startTime.getMonth() + 1);

            let month = startTime.getMonth().toString().length === 1 ?
                ( parseInt(startTime.getMonth().toString(), 10) === 9 ? (parseInt(startTime.getMonth().toString(), 10) + 1) : "0" + (parseInt(startTime.getMonth().toString(), 10) + 1)
                )
                : (startTime.getMonth() + 1);
            let day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
            dateArr.push(year + "-" + month + "-" + day);
            startTime.setDate(startTime.getDate() + 1);
        }
        return dateArr;
    },
    getDate(datestr) {
        var temp = datestr.split("-");
        if (temp[1] === '01') {
            temp[0] = parseInt(temp[0], 10) - 1;
            temp[1] = '12';
        } else {
            temp[1] = parseInt(temp[1], 10) - 1;
        }
        //new Date()的月份入参实际都是当前值-1
        var date = new Date(temp[0], temp[1], temp[2]);
        return date;
    },
    /*
                * 计算两个日期的间隔天数
                * BeginDate:起始日期的文本框，格式為：2012-01-01
                * EndDate:結束日期的文本框，格式為：2012-01-02
                * 返回兩個日期所差的天數
                * 調用方法：
                * alert("相差"+Computation("date1","date2")+"天");
                */
    GetDateRegion(sDate1, sDate2) {
        var aDate, oDate1, oDate2, iDays;
        // var sDate1 = document.getElementById(BeginDate).value;   //sDate1和sDate2是2008-12-13格式
        // var sDate2 = document.getElementById(EndDate).value;
        aDate = sDate1.split("-");
        oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);   //转换为12/13/2008格式
        aDate = sDate2.split("-");
        oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);
        //iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 /24)+1;   //把相差的毫秒数转换为天数
        var i = (oDate1 - oDate2) / 1000 / 60 / 60 / 24;
        if (i < 0) {
            i -= 1;
        }
        else {
            i += 1;
        }
        iDays = i;   //把相差的毫秒数转换为天数
        //alert(iDays);
        return iDays;
    },
    /**
     * 移除对象中值为空的键值对
     * @param obj
     */
    objectRemoveValueIsNull(obj) {
        for (let i in obj) {
            let item = obj[i];
            if (this.isNull(item)) {
                delete obj[i];
            }
        }
    }
    ,
    /**
     * 判断为空
     * @param arg1
     * @returns {boolean}
     */
    isNull(arg1) {
        return !arg1 && arg1 !== 0 && typeof arg1 !== "boolean";
    }
    ,
    /**
     * 判断对象为无属性对象
     * @param e
     * @returns {boolean} 如果为空对象，返回true  如果为非空对象，返回false
     */
    isEmptyObject(e) {
        for (let t in e) return !1;
        return !0;
    }
    ,
    /**
     * 计算年龄
     * @param birthday   1999-10-08
     * @returns {Number}
     */
    getAge(birthday) {
        let birthdayTimestamp = new Date(moment(birthday, "YYYY-MM-DD").format()).getTime();
        let nowTimestamp = new Date().getTime();
        let tempTime = nowTimestamp - birthdayTimestamp;
        let age = parseInt(tempTime / 1000 / 60 / 60 / 24 / 365);
        return age!=null?age:'';
    }
    ,
    /**
     * 回车键事件
     * @param e  事件
     * @param fn  回调函数
     */
    keydownEnter(e, fn) {
        let theEvent = e || window.event;
        let code = theEvent.keyCode || theEvent.which || theEvent.charCode;
        if (code === 13) {
            fn();
        }
    }
    ,
    /**
     * 超出省略
     * @param s 字符串
     * @param len 最大长度
     * @returns {String}
     */
    beyondShowDot(s, len) {
        if (s) {
            let stringLength = s.length;
            if (stringLength <= len) {
                return s;
            } else {
                return s.substr(0, len) + "...";
            }
        } else {
            return "";
        }
    }
    ,
// 获取图片地址。如果网络地址直接显示，如果相对地址，则拼接文件服务器地址和端口
    getPicUrl(url) {
        if (url) {
            if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0 || url.indexOf(".") === 0) {
                return url;
            } else {
                if (url.search(/(jpg|gif|png)/) > -1) {
                    return conf.fileServiceOrigin + url;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    }
    ,
    /*set复制初始数据
    *get获取初始数据和最终数据判断是否有更改
    * */
    setStorageData(data) {
        let storageData = _.clone(data);
        return storageData;
    }
    ,
    getStorageData(data, copyData) {
        let isReminding = _.isEqual(copyData, data);
        return isReminding;
    }
    ,
    /**
     * 通过键和键值获取键值所在对象
     * @param obj
     * @param key
     * @param value
     * @return {*}
     */
    getItemByValue(obj, key, value) {
        for (let item of obj) {
            if (item[key] === value) {
                return item;
            }
        }
        return null;
    }
    ,
    /**
     *获取参数
     * @param obj
     * {
     *     url:String,
     *     arg:String
     * }
     * or
     * @param  obj : String
     * @return {*}
     */
    getQueryArg(obj) {
        return "";
        // let arg = "";
        // let url = "";
        // if(typeof obj === "String"){
        //     url = window.location.href;
        //     arg = obj;
        // }else if(obj.url){
        //     url = obj.url;
        //     arg = obj.arg;
        // }else{
        //     url = window.location.href;
        //     arg = obj.arg;
        // }
        // let queryString = urlUtil.parse(obj.url || window.location.href).query;
        // let queryArg = qs.parse(queryString)[obj.arg];
        //
        // return queryArg || "";
    }
    ,
    trim(str) {
        str = _.trim(str);
        str = str.replace(/\u202D/g, "");
        str = str.replace(/\u202C/g, "");
        return str;
    },
    // gotoLogin() {
    //     window.location.href = conf.loginHost + "?url=" + encodeURIComponent(window.location.href);
    //     // window.location.href = "/login.html"
    // },
    // loginout() {
    //     let s = window.location.href;
    //     let obj = urlUtil.parse(s);
    //     window.location.href = conf.loginHost + "?url=" + encodeURIComponent(obj.protocol + "//" + obj.host);
    // },

    gotoLogin() {
        // window.location.href = conf.loginHost + "?url=" + encodeURIComponent(window.location.href);
        window.location.href = "/login.html"
    },
    loginout() {
        // let s = window.location.href;
        // let obj = urlUtil.parse(s);
        // window.location.href = conf.loginHost + "?url=" + encodeURIComponent(obj.protocol + "//" + obj.host);
        // storageUtil.setSession("token", getparse.token);
        window.location.href = "/login.html";
    }
}
;



// WEBPACK FOOTER //
// ./public/js/util/util.js